import refreshActionType from "./refresh.types";

export const setRefresh = (data) => ({
    type: refreshActionType.SET_REFRESH,
    payload: data
});
